import React, { FC } from 'react';
import FlexGroup from './FlexGroup';
import { ResponsiveContainer } from './ResponsiveContainer';
import styled from '@emotion/styled';

interface NavigationHeaderProps {
  children: React.ReactNode;
}

const Wrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.v1.colors.border.default};
  padding-top: ${({ theme }) => theme.v1.size['2']}px;
  margin-top: ${({ theme }) => theme.v1.size['2']}px;
  width: 100%;
  overflow: hidden;

  .compressed {
    display: none;
  }

  .full-size {
    display: block;
  }

  @container (max-width: ${({ theme }) => theme.v1.navigationBreakpoints.s}px) {
    .compressed {
      display: block;
    }

    .full-size {
      display: none;
    }
  }
`;

const NavigationFooter: FC<NavigationHeaderProps> = ({ children }) => {
  return (
    <ResponsiveContainer data-testid="navigation-footer">
      <Wrapper>
        <FlexGroup alignItems="center" justifyContent="space-between" padding="0">
          {children}
        </FlexGroup>
      </Wrapper>
    </ResponsiveContainer>
  );
};

export default NavigationFooter;
